import { useMsal } from '@azure/msal-react';
import {
  AppBar,
  Avatar,
  Box,
  Container,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Logo from '../logo/logo';
import UserRoleChecker from '../../lib/hooks/userRole';
import AdminNav from '../adminNav';
import profilePic from '../../assets/profile.avif';

const pages = [
  { title: 'Process Invoices', route: '/' },
  { title: 'History', route: '/batchHistory' },
];

const Header = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);
  const [value, setValue] = useState(location.pathname);

  useEffect(() => {
    setValue(location.pathname);
  }, [location]);

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const logout = () => {
    localStorage.removeItem('i_ov');
    sessionStorage.clear();
    instance.logoutRedirect({ account: instance.getActiveAccount() });
  };

  const settings = [
    { text: 'Profile', action: () => navigate('/user/profile') },
    { text: 'Logout', action: logout },
  ];

  const handleChange = (newValue: string) => {
    setValue(newValue);
    navigate(newValue);
  };

  return (
    <AppBar position="static" sx={{ backgroundColor: 'white' }}>
      <Container maxWidth="xl">
        <Toolbar
          disableGutters
          sx={{ justifyContent: 'space-between', color: '#000' }}>
          <div className="w-64">
            <Logo />
          </div>
          <UserRoleChecker>
            {userRole => (
              <>
                {userRole !== 'SuperAdmin' && (
                  <div>
                    {pages.map(page => (
                      <button
                        key={page.route}
                        onClick={() => handleChange(page.route)}
                        style={{
                          margin: '0 10px',
                          cursor: 'pointer',
                          color:
                            value === page.route ? 'rgb(25, 118, 210)' : '#000',
                          textDecoration: 'none',
                          borderBottom: `2px solid ${value === page.route ? 'rgb(25, 118, 210)' : 'transparent'}`,
                          backgroundColor: 'transparent',
                          padding: '8px 16px',
                          textTransform: 'uppercase',
                        }}>
                        {page.title}
                      </button>
                    ))}
                  </div>
                )}
              </>
            )}
          </UserRoleChecker>
          <div className="flex items-center justify-center gap-x-6">
            {/* Use UserRoleChecker to check the user's role */}
            <UserRoleChecker>
              {userRole => {
                // Conditionally render AdminNav based on user role
                return userRole === 'Admin' ? <AdminNav /> : null;
              }}
            </UserRoleChecker>

            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar alt="Remy Sharp" src={profilePic} />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}>
                {settings.map(setting => (
                  <MenuItem
                    key={setting.text}
                    onClick={() => {
                      setting.action();
                      handleCloseUserMenu();
                    }}>
                    <Typography textAlign="center">{setting.text}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          </div>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
